import { styled } from 'styled-components';
import { StyledAlertDialogContent } from '@/shared/ui/alert-dialog/styles';
import { Image } from '@/shared/ui/image/Image';
import { Box } from '@/shared/ui/box/Box';

const StyledTermsReminderDialogContent = styled(StyledAlertDialogContent)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 420px;
  padding: 12px;
  box-sizing: border-box;
  max-height: 90dvh;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    padding-bottom: calc(12px + var(--app-safe-area-bottom));
  }
`;

const Navigation = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  flex-shrink: 0;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  flex: 1;
  min-height: 0;
`;

const ListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  flex: 1;
  min-height: 0;
`;

const LogoWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  flex-shrink: 0;
`;

const ListBox = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 329px;
  min-height: 0;
  padding: 0 4px 0 12px;
  border-radius: 8px;
  background: #27262b;
  overflow: hidden;

  @media (max-width: 768px) {
    max-height: none;
    flex: 1;
  }
`;

const ListScrollArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  flex: 1;
  min-height: 0;
  margin: 12px 0;
  padding-right: 8px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(175, 175, 175, 0.5) transparent;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(175, 175, 175, 0.5);
    border-radius: 8px;
  }
`;

const ListTitle = styled(Box)`
  flex-shrink: 0;
`;

const StepsList = styled.ol`
  margin: 0;
  padding-left: 18px;
  list-style-type: disc;
  color: #afafaf;

  & ::marker {
    font-size: 0.7em;
  }
`;

const LogoImage = styled(Image)`
  & img {
    width: max-content;
    height: max-content;
  }
`;

export {
  StyledTermsReminderDialogContent,
  Navigation,
  InfoContainer,
  ListSection,
  LogoWrapper,
  ListBox,
  ListScrollArea,
  ListTitle,
  StepsList,
  LogoImage,
};
